import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OfferDetailsComponent } from './offer-details.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: '', component: OfferDetailsComponent }
    ])
  ],
  exports: [RouterModule]
})
export class OfferDetailsRoutingModule { }
